<template>
  <div>
    <div class="home-content">
      <div class="box school-service">
        <div class="box-title">学校服务</div>
        <div class="box-content">
          <img
            class="bg-icon"
            src="@/assets/images/user-rights/bg.png"
            alt=""
          />
          <div class="info-item">
            <span class="label">学校：</span>
            <div class="text">{{ userInfo.schoolName }}</div>
          </div>
          <div class="info-item">
            <span class="label">服务：</span>
            <div class="service-box">
              <div
                class="service-item"
                v-for="item in userInfo.roles"
                :key="item.roleName"
              >
                {{ item.roleName }} <span class="text">(剩余</span
                >{{ item.validDays }}<span class="text">天)</span>
              </div>
              <div
                class="service-item"
                v-if="
                  userInfo.resourceCardVO &&
                  userInfo.resourceCardVO.resourceCardBalance
                "
              >
                学科网通享卡<span class="text"
                  >({{
                    userInfo.resourceCardVO.schoolChargeUsedType == 1
                      ? "学校共享"
                      : "个人"
                  }}余额</span
                >{{ userInfo.resourceCardVO.resourceCardBalance
                }}<span class="text">元)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="equity-banner" data-io-click="tracker"  @click="jumpRightPage">
        <img src="@/assets/images/user-rights/member-entry.png" alt="" />
        <div class="icon-list">
          <div class="icon-item">
            <img src="@/assets/images/user-rights/content-icon.png" alt="" />
            <div class="icon-text">内容权益</div>
          </div>
          <div class="icon-item">
            <img src="@/assets/images/user-rights/function-icon.png" alt="" />
            <div class="icon-text">功能权益</div>
          </div>
          <div class="icon-item">
            <img src="@/assets/images/user-rights/service-icon.png" alt="" />
            <div class="icon-text">服务权益</div>
          </div>
        </div>
      </div>
      <div class="box history-box">
        <div class="box-title">我的足迹</div>
        <div class="check-tab">
          <div
            class="tab-btn"
            :class="{ active: activeIndex == 0 }"
            data-io-click="tracker"  @click="activeIndex = 0"
          >
            我的下载
          </div>
          <div
            class="tab-btn"
            :class="{ active: activeIndex == 1 }"
            data-io-click="tracker"  @click="activeIndex = 1"
          >
            我的收藏
          </div>
        </div>
        <div class="box-content">
          <div
            class="soft-item"
            v-if="historyLists.length"
            v-for="item in historyLists"
            :key="item.softId"
          >
            <div class="left-text">
              <div class="left-icon">
                <div class="circle"></div>
                <div class="line"></div>
              </div>
              <span
                class="soft-name"
                data-io-click="tracker"  @click="handleOpenPreview(1, item.softId, item)"
                >{{ item.softName }}</span
              >
            </div>
            <div class="time">{{ item.date.split(" ")[0] }}</div>
          </div>
          <div
            class="more-btn"
            v-if="historyLists.length"
            data-io-click="tracker"  @click="jumpUserPage"
          >
            更多
          </div>
          <div class="occupy-box" v-if="!historyLists.length">
            <div class="img-icon">
              <img src="@/assets/images/no-record2.png" alt="" />
            </div>
            <div class="text">暂无{{ !activeIndex ? "下载" : "收藏" }}内容</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserDownload, getUserFavorite } from "@/utils/apis";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["userInfo"]),
    historyLists() {
      return this.activeIndex == 0 ? this.userDownloads : this.userCollections;
    },
  },
  data() {
    return {
      activeIndex: 0,
      userDownloads: [],
      userCollections: [],
    };
  },
  mounted() {
    this.loadDownloadList();
    this.loadCollections();
  },
  methods: {
    jumpRightPage() {
      window.open(
        `/equity${this.$route.query.xep_flag === "1" ? "?xep_flag=1" : ""}`
      );
    },
    handleOpenPreview(type, softId, item) {
      console.log("item", item);
      const isPaper = item.resourceType === 2;
      if (isPaper) {
        if (this.isInIframe) {
          window.XEP.router.open(`/shk/paper/preview/${softId}`, false);
        } else {
          window.open(`/shk/paper/preview/${softId}`, "_blank");
        }
        return;
      }
      let {
        isLHSData,
        isVirtualExperiment,
        isNBExperiment,
        isZKExperiment,
        isGKExperiment,
      } = item;
      let subjectFeatureType = "";
      if (isLHSData) {
        subjectFeatureType = "scsy";
      } else if (isVirtualExperiment) {
        subjectFeatureType = "hmkt";
      } else if (isNBExperiment) {
        subjectFeatureType = "nbsy";
      } else if (isZKExperiment) {
        subjectFeatureType = "zksy";
      } else if (isGKExperiment) {
        subjectFeatureType = "gksy";
      }
      let typeId = item && (item.typeId || String(item.resourceType));
      let isMaterialPreview =
        typeId && typeId.startsWith("3106") && typeId.length > 4;
      type = isMaterialPreview ? 6 : type;
      let { xep_flag } = this.$route.query;
      let url = `/soft/${softId}-${type}.html`;
      let params = [];
      if (subjectFeatureType) {
        params.push(`subjectFeatureType=${subjectFeatureType}`);
      }
      if (xep_flag === "1") {
        params.push("xep_flag=1");
      }
      window.open(`${url}${params.length ? "?" + params.join("&") : ""}`);
    },
    jumpUserPage() {
      if (!this.activeIndex) {
        this.$router.push("/user/download");
      } else {
        this.$router.push("/user/collection");
      }
    },
    async loadDownloadList() {
      const data = await getUserDownload({
        page: 1,
      });
      if (data.code === 200) {
        let { list: result, totalPages } = data.result;
        console.log("result", result);
        this.userDownloads = result || [];
      }
    },
    async loadCollections() {
      const data = await getUserFavorite({
        page: 1,
      });
      if (data.code === 200) {
        let { list: result, totalPages } = data.result;
        console.log("result", result);
        this.userCollections = result || [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home-content {
  width: 1080px;
  margin: 0 auto;
  margin-top: 48px;
  .box {
    .box-title {
      font-size: 18px;
      line-height: 26px;
      position: relative;
      margin-bottom: 24px;
      &::after {
        display: block;
        position: absolute;
        content: "";
        bottom: -8px;
        left: 0px;
        width: 31px;
        height: 2px;
        background: #0057ff;
      }
    }
    .check-tab {
      display: flex;
      width: 188px;
      padding: 6px;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background: #f6f6f6;
      margin-bottom: 16px;
      .tab-btn {
        padding: 6px 16px;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        color: #1a1a1a;
        &.active {
          background: #fff;
          color: #0057ff;
        }
      }
    }
    .box-content {
      border-radius: 8px;
      background: #fff;
      border: 1px solid #e2e2e2;
      padding: 24px;
      position: relative;
      overflow: hidden;
      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        font-size: 14px;
        .label {
          color: #7e7e7e;
          width: 48px;
        }
        .text {
          color: #1a1a1a;
        }
        .service-box {
          width: calc(100% - 48px);
          display: flex;
          flex-wrap: wrap;
          .service-item {
            color: #b6915d;
            margin-right: 28px;
            .text {
              color: #1a1a1a;
            }
          }
        }
        &:last-child {
          margin-bottom: 0px;
          align-items: baseline;
        }
      }
      .bg-icon {
        width: 252px;
        height: 138px;
        position: absolute;
        top: -16px;
        right: -0;
      }
    }
    &.history-box {
      .box-content {
        .soft-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          line-height: 1;
          font-size: 14px;
          cursor: pointer;
          .left-text {
            display: flex;
            align-items: flex-start;
            .left-icon {
              margin-right: 8px;
              .circle {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                border: 1px solid #bababa;
                margin: 3px 0;
              }
              .line {
                height: 24px;
                width: 1px;
                margin-left: 7.5px;
                background: #e2e2e2;
              }
            }
            .soft-name {
              color: #1a1a1a;
              line-height: 22px;
            }
          }
          &:hover {
            .left-text {
              .soft-name {
                color: #0057ff;
              }
            }
          }
          .time {
            color: #7e7e7e;
          }
          &:nth-last-child(2) {
            .left-text {
              .left-icon {
                .line {
                  display: none;
                }
              }
            }
          }
        }
        .more-btn {
          text-align: center;
          color: #0057ff;
          font-size: 14px;
          margin-top: 24px;
          cursor: pointer;
        }
      }
    }
  }
  .equity-banner {
    width: 100%;
    height: 100px;
    margin: 32px 0;
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    .icon-list {
      position: absolute;
      right: 0;
      top: 0;
      padding: 0 120px 0 94px;
      height: 100%;
      display: flex;
      align-items: center;
      .icon-item {
        display: flex;
        flex-direction: column;
        margin-right: 102px;
        img {
          width: 48px;
          height: 48px;
        }
        .icon-text {
          color: #e3cc9c;
          font-size: 14px;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
.occupy-box {
  text-align: center;
  padding-top: 12px;
  width: 100%;
  .img-icon {
    width: 100%;
    margin-bottom: 12px;
    height: 96px;
    text-align: center;
    img {
      height: 100%;
      width: 175px;
    }
  }
  .text {
    line-height: 24px;
    font-size: 16px;
    color: #7e7e7e;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
      font-size: 14px;
      line-height: 22px;
      color: #0057ff;
      margin-left: 12px;
      .iconfont {
        transform: rotate(-90deg) scale(0.8);
        display: inline-block;
        font-size: 12px;
      }
    }
  }
}
</style>
